/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  const staticInstallationName = "MERA HelpDesk";

  /**
   * Replaces "Chatwoot" in text with the static name "MERA HelpDesk".
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by the static name.
   */
  const replaceInstallationName = text => {
    if (!text) {
      return text;
    }
    return text.replace(/Chatwoot/g, staticInstallationName);
  };

  return {
    replaceInstallationName,
  };
}
